import {GoogleAnalytics} from './google/googleAnalytics';
import {MetaAnalyticsBridge} from './meta/metaAnalyticsBridge';
import {AnalyticsEvent} from './events';

interface IAnalytics {
  logEvent: (event: AnalyticsEvent) => void;
  setUserId: (userId: string) => void;
  clearUserId: () => void;
  setUserProperties: (props: Record<string, unknown>) => void;
  setDefaultParameters: (params: Record<string, unknown>) => void;
  setSessionId: (id: string) => void;
  clearSessionId: () => void;
  clearUserSession: () => void;
}

export const Analytics: IAnalytics = {
  logEvent: async (event: AnalyticsEvent) => {
    GoogleAnalytics.logEvent(event);
    MetaAnalyticsBridge.logEvent(event);
  },
  setUserId: GoogleAnalytics.setUserId,
  clearUserId: GoogleAnalytics.clearUserId,
  setUserProperties: GoogleAnalytics.setUserProperties,
  setDefaultParameters: GoogleAnalytics.setDefaultParameters,
  setSessionId: GoogleAnalytics.setSessionId,
  clearSessionId: GoogleAnalytics.clearSessionId,
  clearUserSession: GoogleAnalytics.clearUserSession,
};
